import styled from "styled-components";
import { device } from "../../helpers";

export const Container = styled.div`
    position: relative;
    margin: 36px auto 36px auto;
    width: 1000px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;

    @media ${device.phone} {
        margin: 10px auto 24px auto;
        width: 100%;
        flex-direction: column;
    }
`;
export const ImageCol = styled.div`
    max-width: 400px;
    margin-left: 60px;

    @media ${device.phone} {
        display: flex;
        flex-direction: column;
        max-width: 100%;
        margin-left: 0;
        align-items: center;
    }
`;
export const TOCColumn = styled.div`
    width: 600px;
    max-width: 600px;

    @media ${device.phone} {
        display: none;
    }
`;

export const Meta = styled.div`
    text-align: right;
    width: 94%;
    margin-right: 5%;

    @media ${device.phone} {
        width: 90%;
        margin-right: 0;
    }
`;
export const Image = styled.img`
    cursor: pointer;
    width: 100%;
    border-radius: 4px;

    @media ${device.phone} {
        width: 85%;
    }
`;
export const Title = styled.h1`
    margin: 20px 0 0 0;
    padding: 0;
    font-size: 20px;
    font-weight: 700 !important;
    text-align: center;
    font-family: urdu, QuranFont, sans-serif;

    [lang="ar"] {
        font-size: 18px;
    }
`;
export const Authors = styled.div`
    margin-top: 0;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 20px;

    @media ${device.phone} {
        margin: 5px 0 20px 0;
    }
`;
export const Intro = styled.div`
    margin: 20px 0 24px 0;
    line-height: 26px;

    [lang="ar"] {
        font-size: 15px;
    }

    span[text="ؓ"],
    span[text="ؑ"] {
        font-size: 10px;
    }

    @media ${device.phone} {
        margin: 20px 36px 24px 36px;
        text-align: center;
    }
`;
export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    margin-top: 12px;

    @media ${device.phone} {
        justify-content: center;
    }
`;
export const ActionImg = styled.img`
    cursor: pointer;
    margin: 6px 10px 0 0;
    height: 24px;
`;
export const ActionRow = styled.div`
    margin: 10px 0 0 0;
    display: flex;
    flex-direction: row;
`;
